import React, { useEffect, useMemo } from "react";
import "../style/page/Donations.css";
import { useDonationsContent } from "../hooks/useDonationsContent";
import LogoStrip from "../component/HomePage/LogoStrip";
import DonationsTable from "../component/DonationsTable";
import { useHomePageContent } from "../hooks/useHomePageContent";
import { useLogoStripCarousel } from "../hooks/websiteHooks";
function Donations() {
  const { title, description, cardsHtml, metaTitle, projects, headerTexts } = useDonationsContent();
  const { logoStrips } = useHomePageContent();

  useEffect(() => {
    if (metaTitle) {
      document.title = metaTitle;
    }
  }, [metaTitle]);

  const donationsStrip = useMemo(() => {
    return logoStrips.find((section) => section.slug === "donations") || null;
  }, [logoStrips]);

  useLogoStripCarousel([donationsStrip?.items?.length || 0]);

  return (
    <main className="main-content donations-page">
      <h4 className="page-title">{title}</h4>

      <p className="description">{description}</p>

      <div className="contact-wrapper" dangerouslySetInnerHTML={{ __html: cardsHtml }} />

      <DonationsTable projects={projects} headerTexts={headerTexts} />

      {donationsStrip && <LogoStrip id={donationsStrip.slug} title={donationsStrip.title} items={donationsStrip.items} />}
    </main>
  );
}

export default Donations;
